module.exports = __webpack_public_path__ + "img/card1.348ea9a4.png";